import React from 'react'
export default function PDFURL(props) {
  return (
    <div>
     <embed src={`data:application/pdf;base64,${props.base64data}`} width="100%" height="800px"
            type="application/pdf" />
    </div>
  )
}
